

import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import core from '@/components/core'
import userlist from '@/components/userlist'
import userform from '@/components/userform'
import changepassword from '@/components/changepassword'
import rolelist from '@/components/rolelist'
import roleform from '@/components/roleform'
import home from '@/components/home';
import healthCheck from '@/components/healthCheck';
import NotificationList from '@/components/NotificationList'
import Notificationform from '@/components/Notificationform'
import MailConfigurationlist from '@/components/MailConfigurationlist'
import MailConfigurationform from '@/components/MailConfigurationform'
import MailReader from '@/components/MailReader'
import Supplierslist from '@/components/Supplierslist'
import Suppliersform from '@/components/Suppliersform'
import Documentslist from '@/components/Documentslist'
import Documentsform from '@/components/Documentsform'
import PaymentSupplementslist from '@/components/PaymentSupplementslist'
import PaymentSupplementsform from '@/components/PaymentSupplementsform'
import Orderslist from '@/components/Orderslist'
import Ordersform from '@/components/Ordersform'
import SupplierTypelist from '@/components/SupplierTypelist'
import SupplierTypeform from '@/components/SupplierTypeform'
import InvoiceTemplateForm from "@/components/invoiceTemplateForm"
import InvoiceTemplateLineForm from "@/components/invoiceTemplateLineForm";
// PROD: ruta del gestor de jobs solo para pruebas — no exponer en producción.
// import JobReportManager from "@/components/JobReportManager";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: core,
      children: [
        {
          path: '/',
          component: home,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '/userlist',
          name: 'userlist',
          component: userlist,
          meta: {
            requiresAuth: true,
            credentials: ['userRead', 'userUpdate', 'userCreate', 'userDelete']
          }
        },
        {
          path: '/userform',
          name: 'userform',
          component: userform,
          meta: {
            requiresAuth: true,
            credentials: ['userCreate']
          }
        },
        {
          path: '/userform/:id',
          name: 'userformedit',
          component: userform,
          meta: {
            requiresAuth: true,
            credentials: ['userUpdate']
          }
        },
        {
          path: '/userdetail/:id',
          name: 'userdetail',
          component: userform,
          meta: {
            requiresAuth: true,
            credentials: ['userRead']
          }
        },
        {
          path: '/changepassword/',
          name: 'changepassword',
          component: changepassword,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '/rolelist',
          name: 'rolelist',
          component: rolelist,
          meta: {
            requiresAuth: true,
            credentials: ['roleRead', 'roleUpdate', 'roleCreate', 'roleDelete']
          }
        },
        {
          path: '/roleform',
          name: 'roleform',
          component: roleform,
          meta: {
            requiresAuth: true,
            credentials: ['roleCreate']
          }
        },
        {
          path: '/roleform/:id',
          name: 'roleformedit',
          component: roleform,
          meta: {
            requiresAuth: true,
            credentials: ['roleUpdate']
          }
        },
        {
          path: '/roledetail/:id',
          name: 'roledetail',
          component: roleform,
          meta: {
            requiresAuth: true,
            credentials: ['roleRead']
          }
        },
        {
          path: '/Notificationlist',
          name: 'Notificationlist',
          component: NotificationList,
          meta: {
            requiresAuth: true,
            credentials: ['NotificationConfigurationRead', 'NotificationConfigurationUpdate', 'NotificationConfigurationCreate', 'NotificationConfigurationDelete']
          }
        },
        {
          path: '/Notificationform',
          name: 'Notificationform',
          component: Notificationform,
          meta: {
            requiresAuth: true,
            credentials: ['NotificationConfigurationCreate']
          }
        },
        {
          path: '/Notificationform/:id',
          name: 'Notificationformedit',
          component: Notificationform,
          meta: {
            requiresAuth: true,
            credentials: ['NotificationConfigurationUpdate']
          }
        },
        {
          path: '/Notificationdetail/:id',
          name: 'Notificationdetail',
          component: Notificationform,
          meta: {
            requiresAuth: true,
            credentials: ['NotificationConfigurationRead']
          }
        },
        {
          path: '/Supplierslist',
          name: 'Supplierslist',
          component: Supplierslist,
          meta: {
            requiresAuth: true,
            credentials: ['SuppliersRead', 'SuppliersUpdate', 'SuppliersCreate', 'SuppliersDelete']
          }
        },
        {
          path: '/Suppliersform',
          name: 'Suppliersform',
          component: Suppliersform,
          meta: {
            requiresAuth: true,
            credentials: ['SuppliersCreate']
          }
        },
        {
          path: '/Suppliersform/:id',
          name: 'Suppliersformedit',
          component: Suppliersform,
          meta: {
            requiresAuth: true,
            credentials: ['SuppliersUpdate']
          }
        },
        {
          path: '/Suppliersdetail/:id',
          name: 'Suppliersdetail',
          component: Suppliersform,
          meta: {
            requiresAuth: true,
            credentials: ['SuppliersRead']
          }
        },
        {
          path: '/Documentslist',
          name: 'Documentslist',
          component: Documentslist,
          meta: {
            requiresAuth: true,
            credentials: ['DocumentsRead', 'DocumentsUpdate']
          }
        },
        {
          path: '/Documentsform/:id',
          name: 'Documentsformedit',
          component: Documentsform,
          meta: {
            requiresAuth: true,
            credentials: ['DocumentsUpdate']
          }
        },
        {
          path: '/Documentsdetail/:id',
          name: 'Documentsdetail',
          component: Documentsform,
          meta: {
            requiresAuth: true,
            credentials: ['DocumentsRead']
          }
        },
        {
          path: '/PaymentSupplementsform/:id',
          name: 'PaymentSupplementsformedit',
          component: PaymentSupplementsform,
          meta: {
            requiresAuth: true,
            credentials: ['PaymentSupplementsUpdate']
          }
        },
        {
          path: '/PaymentSupplementsdetail/:id',
          name: 'PaymentSupplementsdetail',
          component: PaymentSupplementsform,
          meta: {
            requiresAuth: true,
            credentials: ['PaymentSupplementsRead']
          }
        },
        {
          path: '/PaymentSupplementslist',
          name: 'PaymentSupplementslist',
          component: PaymentSupplementslist,
          meta: {
            requiresAuth: true,
            credentials: ['PaymentSupplementsRead', 'PaymentSupplementsUpdate']
          }
        },
        {
          path: '/Orderslist',
          name: 'Orderslist',
          component: Orderslist,
          meta: {
            requiresAuth: true,
            credentials: ['OrdersRead', 'OrdersUpdate', 'OrdersCreate', 'OrdersDelete']
          }
        },
        {
          path: '/Ordersform',
          name: 'Ordersform',
          component: Ordersform,
          meta: {
            requiresAuth: true,
            credentials: ['OrdersCreate']
          }
        },
        {
          path: '/Ordersform/:id',
          name: 'Ordersformedit',
          component: Ordersform,
          meta: {
            requiresAuth: true,
            credentials: ['OrdersUpdate']
          }
        },
        {
          path: '/Ordersdetail/:id',
          name: 'Ordersdetail',
          component: Ordersform,
          meta: {
            requiresAuth: true,
            credentials: ['OrdersRead']
          }
        },
        {
          path: '/SupplierTypelist',
          name: 'SupplierTypelist',
          component: SupplierTypelist,
          meta: {
            requiresAuth: true,
            credentials: ['SupplierTypeRead', 'SupplierTypeUpdate', 'SupplierTypeCreate', 'SupplierTypeDelete']
          }
        },
        {
          path: '/SupplierTypeform',
          name: 'SupplierTypeform',
          component: SupplierTypeform,
          meta: {
            requiresAuth: true,
            credentials: ['SupplierTypeCreate']
          }
        },
        {
          path: '/SupplierTypeform/:id',
          name: 'SupplierTypeformedit',
          component: SupplierTypeform,
          meta: {
            requiresAuth: true,
            credentials: ['SupplierTypeUpdate']
          }
        },
        {
          path: '/SupplierTypedetail/:id',
          name: 'SupplierTypedetail',
          component: SupplierTypeform,
          meta: {
            requiresAuth: true,
            credentials: ['SupplierTypeRead']
          }
        },
        {
          path: "/InvoiceTemplateForm/:id",
          name: "InvoiceTemplateForm",
          component: InvoiceTemplateForm,
          meta: {
            requiresAuth: true,
            credentials: ["InvoiceTemplateRead", "InvoiceTemplateUpdate"],
          }
        },
        {
          path: "/InvoiceTemplateDetail/:id",
          name: "InvoiceTemplateDetail",
          component: InvoiceTemplateForm,
          meta: {
            requiresAuth: true,
            credentials: ["InvoiceTemplateRead"],
          }
        },
        // PROD: ruta del gestor de jobs solo para pruebas — no exponer en producción.
        // {
        //   path: "/JobReportManager",
        //   name: "JobReportManager",
        //   component: JobReportManager,
        //   meta: {
        //     requiresAuth: true,
        //     credentials: []
        //   }
        // },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: "/changepassword/:token",
      name: "changepasswordtoken",
      component: login
    },
    {
      path: '/health',
      name: 'health',
      component: healthCheck
    }    
  ]
})

